<template>
    <div class="cartcontroll notranslate">
        <transition name="slide-fade">
            <mu-button icon color="primary" :class="packageType == 0 ? 'decrease' : 'decrease-buffet'"
                v-show="food.quantity" @click="decreaseCart">
                <mu-icon value="remove_circle"></mu-icon>
            </mu-button>
        </transition>
        <div :class="packageType == 0 ? 'count' : 'count-buffet'" v-show="food.quantity">{{ food.quantity }}</div>

        <mu-button icon color="primary" :class="(addType === true || food.unAdd) ? 'form-onlyread' : 'add'"
            @click="addCart" v-show="(food.groupId == null) || (food.groupId != null && food.quantity)">
            <mu-icon value="add_circle"></mu-icon>
        </mu-button>

        <mu-badge :content="food.unPayTip" v-if="food.unPayTip"
            style="position:absolute;width:180px;right:0px;top:-20px;z-index: 10000;"></mu-badge>

        <mu-badge :content="getWith()" color="#da5b3a" badge-class="badge-class" @click="openTasteSheet(food.groupId)"
            v-if="(addType === false && !food.unAdd)" v-show="food.groupId != null && !food.quantity"></mu-badge>

        <mu-bottom-sheet :open.sync="open"
            style="overflow-y: auto; height: 80%; border-radius: 20px 20px 0 0;">
            <mu-list @item-click="closeTasteSheet" class="taste-sheet-list">
                <div class="taste-header" :class="{ 'has-image': hasImage(food.foodImage) }">
                    <img v-if="hasImage(food.foodImage)" class="taste-header-img"
                        :src="getImgUrl(food.foodImage, 400)" />
                    <div v-if="hasImage(food.foodImage)" class="taste-header-mask"></div>
                    <div class="taste-header-name">{{ food.foodName }}</div>
                    <div class="taste-close notranslate" @click="closeTasteSheet">
                        <mu-icon value="close" size="24"></mu-icon>
                    </div>
                </div>

                <div class="taste-body">
                    <!-- model=1：单选/多选口味 -->
                    <div class="taste-group" v-for="(parentItem, index) in modelOneGroups"
                        :key="parentItem.id || index">
                        <div class="taste-group-title">
                            {{ parentItem.attributeName }}
                            <span v-if="isRequired(parentItem)" class="required-mark">*</span>
                        </div>
                        <div class="taste-options">
                            <div v-for="item in parentItem.children" @click="selectTastes(item)" :key="item.id"
                                class="taste-option"
                                :class="item.isChoice ? 'stateChoose' : 'stateNotChoose'">
                                <span class="taste-option-name">{{ item.attributeName }}</span>
                                <span v-if="isShowPrice(parentItem)" class="taste-option-price">
                                    {{ getAttributeDisplayPrice(parentItem, item) }} {{ seller.unit }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- model=2：数量选择，直接展示在 model=1 下方 -->
                    <div class="taste-group" v-for="(parentItem, index) in modelTwoGroups"
                        :key="parentItem.id || ('mul' + index)">
                        <div class="taste-group-title">
                            {{ parentItem.attributeName }}
                            <span v-if="isRequired(parentItem)" class="required-mark">*</span>
                        </div>
                        <div class="mul-rows">
                            <div class="mul-row" v-for="item in parentItem.children" :key="item.id">
                                <div class="mul-stepper">
                                    <button class="mul-btn" @click="changeMulNum(parentItem, item, -1)">-</button>
                                    <input class="mul-input" type="number" min="0" v-model.number="item.num"
                                        @change="validateMulNum(parentItem, item)">
                                    <button class="mul-btn" @click="changeMulNum(parentItem, item, 1)">+</button>
                                </div>
                                <span class="mul-name">{{ item.attributeName }}</span>
                                <span v-if="isShowPrice(parentItem)" class="mul-price">
                                    {{ item.attributePrice }} {{ seller.unit }}
                                </span>
                            </div>
                        </div>
                        <div class="mul-limit" v-if="showGroupLimit(parentItem)">
                            {{ groupSelectedTotal(parentItem) }} / {{ groupMaxPortion(parentItem) }}
                        </div>
                    </div>

                    <div class="taste-summary" v-if="food.decideName">
                        <span class="taste-summary-label">{{ $t('orderList.choice') }}</span>
                        <span class="taste-summary-value">{{ food.decideName }}</span>
                    </div>

                    <div class="taste-total">
                        <span class="taste-total-label">{{ $t('orderList.total') }}</span>
                        <span class="taste-total-price">{{ food.payAmount }}<em>{{ seller.unit }}</em></span>
                    </div>

                    <div class="taste-actions">
                        <mu-button class="taste-confirm" large full-width @click="sureTasteSheet">
                            {{ $t('common.sure') }}
                        </mu-button>
                    </div>
                </div>
            </mu-list>
        </mu-bottom-sheet>

    </div>
</template>

<script>
import Vue from 'vue'
import { eventBus } from '../utils/event-bus'

export default {
    props: {
        packageType: {
            type: Number,
            default: 0
        },
        food: {
            type: Object
        },
        addType: {
            type: Boolean
        },
        personNum: {
            type: Number,
            default: 1
        },
    },
    data() {
        return {
            foodAttributeAll: [],
            foodAttribute: [],
            open: false,
            tableOrderInfo: {},
            seller: {},
        }
    },
    created() {
    },
    mounted() {
    },
    computed: {
        // model=1：口味选择组
        modelOneGroups() {
            return this.foodAttribute.filter(item => item.model != 2);
        },
        // model=2：数量选择组
        modelTwoGroups() {
            return this.foodAttribute.filter(item => item.model == 2);
        }
    },
    methods: {
        addCart(e) {
            const curQty = this.food.quantity || 0;
            // PerMaxCopies：含已下单的累计上限
            const cumMax = this.personCumulativeMax();
            if (cumMax !== Infinity && curQty >= cumMax) {
                this.$alert(this.$t('orderList.onePersonOrder', { num: this.food.perMaxCopies }) + ' ' + this.food.foodName, this.$t('common.alert'), { okLabel: this.$t('common.sure') });
                return;
            }
            // EveryTimeCopies：本次可点上限（与人数无关）
            const orderMax = this.perOrderMax();
            if (orderMax !== Infinity && curQty >= orderMax) {
                this.$alert(this.$t('orderList.maxEachTimeOrder', { num: this.food.everyTimeCopies }) + ' ' + this.food.foodName, this.$t('common.alert'), { okLabel: this.$t('common.sure') });
                return;
            }
            if (!this.food.quantity) {
                Vue.set(this.food, 'quantity', 1);
                if (this.food.chargedOnce == 1 && this.food.payAmount > 0) {
                    var tips = this.$t("orderList.chargedOnceTips");
                    if (window.localStorage.getItem('oneTimeCharge') != undefined && window.localStorage.getItem('oneTimeCharge') != null && window.localStorage.getItem('oneTimeCharge') != '') {
                        tips = window.localStorage.getItem('oneTimeCharge');
                    }
                    this.$alert(tips, this.$t("common.alert"), { okLabel: this.$t("common.sure") });
                }
            } else {
                this.food.quantity += 1;
            }

            // 优化体验，异步传递当前点击文档节点
            this.$nextTick(() => {
                eventBus.$emit('addcart', e.target)
            })
        },
        decreaseCart() {
            if (this.food.quantity) {
                this.food.quantity--
                // 有独立口味记录时，同步移除最后一份的配置
                if (Array.isArray(this.food.tasteList) && this.food.tasteList.length > this.food.quantity) {
                    this.food.tasteList.pop();
                    this.refreshTasteRecord();
                }
                if (this.food.quantity == 0) {
                    Vue.set(this.food, 'payAmount', this.food.price)
                }
            }
        },
        getWith() {
            return this.$t('orderList.with');
        },
        getImgUrl(image, w) {
            if (!this.hasImage(image)) {
                return '';
            }
            return this.global.baseUrl + 'api/images/' + (w || 0) + '/' + image;
        },
        // 是否配置了真实菜品图片（为空或默认图时不展示）
        hasImage(image) {
            if (image == undefined || image == 'undefined' || image == null || image === '') {
                return false;
            }
            return String(image).toLowerCase().indexOf('default.png') === -1;
        },
        // 解析分组属性上的 extJson
        getExtJson(parentItem) {
            if (!parentItem || !parentItem.extJson) return {};
            try {
                const ext = typeof parentItem.extJson === 'string'
                    ? JSON.parse(parentItem.extJson)
                    : parentItem.extJson;
                return ext || {};
            } catch (e) {
                return {};
            }
        },
        // 是否默认选择第一项（isDefault 为 null/undefined/true 时默认选中）
        isDefault(parentItem) {
            const ext = this.getExtJson(parentItem);
            return ext.isDefault !== false && ext.isDefault !== 'false';
        },
        // 分组是否必选
        isRequired(parentItem) {
            const ext = this.getExtJson(parentItem);
            return ext.isRequired === true || ext.isRequired === 'true';
        },
        // 是否自助菜品（isSeft=1 时属性价格一律为 0 且不显示价格）
        isSelfFood() {
            return Number(this.food.isSeft) == 1;
        },
        // 是否展示价格（showPrice 为 null 或 true 时展示，false 时隐藏；自助菜品不显示价格）
        isShowPrice(parentItem) {
            if (this.isSelfFood()) return false;
            const ext = this.getExtJson(parentItem);
            return ext.showPrice !== false && ext.showPrice !== 'false';
        },
        // 分组最大可选数量（maxPortion 为 null/0 时不限制）
        groupMaxPortion(parentItem) {
            const maxPortion = Number(this.getExtJson(parentItem).maxPortion);
            return maxPortion > 0 ? maxPortion : Infinity;
        },
        showGroupLimit(parentItem) {
            return this.groupMaxPortion(parentItem) !== Infinity;
        },
        // 当前分组已选数量
        groupSelectedTotal(parentItem) {
            return parentItem.children.reduce((sum, item) => sum + (Number(item.num) || 0), 0);
        },
        // PerMaxCopies：每人累计上限（含已下单，组内数量不受此约束）
        personCumulativeMax() {
            const perMaxCopies = Number(this.food.perMaxCopies);
            return perMaxCopies > 0 ? perMaxCopies * (Number(this.personNum) || 1) : Infinity;
        },
        // EveryTimeCopies：每次可点上限（与人数无关，仅约束本次弹窗新增份数）
        perOrderMax() {
            const every = Number(this.food.everyTimeCopies);
            return every > 0 ? every : Infinity;
        },
        // 根据父属性 ExtJson 中的 priceIncrease 字段决定展示价格
        // priceIncrease === false：仅显示 item.attributePrice
        // 其他情况（ExtJson 为空、无内容、无 priceIncrease、priceIncrease=true）：显示 food.price + item.attributePrice
        // 自助菜品（isSeft=1）属性价格一律按 0 显示
        getAttributeDisplayPrice(parentItem, item) {
            if (this.isSelfFood()) return 0;
            const addFoodPrice = this.getExtJson(parentItem).priceIncrease !== false;
            return addFoodPrice
                ? (this.food.price + item.attributePrice)
                : item.attributePrice;
        },
        // model=1 口味选择（各组互不影响，仅单选组内部互斥）
        selectTastes(it) {
            this.foodAttribute.forEach((group) => {
                if (group.model == 2) return;
                // 只处理点击项所在的组，避免影响其他组的选择
                const sameGroup = group.id == it.parentId;
                if (!sameGroup) return;
                group.children.forEach((child) => {
                    if (child.id == it.id) {
                        child.isChoice = !child.isChoice;
                    } else if (group.model == 1) {
                        child.isChoice = false;
                    }
                });
            });
            this.recalcTaste();
        },
        // model=2 数量增减
        // 注意：PerMaxCopies/EveryTimeCopies 只在外层 sureTasteSheet 校验，组内数量只受 extJson.maxPortion 约束
        changeMulNum(parentItem, item, delta) {
            const next = (Number(item.num) || 0) + delta;
            if (next < 0) return;
            if (delta > 0) {
                if (this.groupSelectedTotal(parentItem) >= this.groupMaxPortion(parentItem)) {
                    this.$alert(this.$t('orderList.maxiNum') + ': ' + this.groupMaxPortion(parentItem), this.$t('common.alert'), { okLabel: this.$t('common.sure') });
                    return;
                }
            }
            item.num = next;
            this.recalcTaste();
        },
        // model=2 手动输入数量校验（组内只受 maxPortion 约束）
        validateMulNum(parentItem, item) {
            let num = parseInt(item.num, 10);
            if (isNaN(num) || num < 0) num = 0;
            const current = Number(item.num) || 0;
            const groupOther = this.groupSelectedTotal(parentItem) - current;
            const groupMax = this.groupMaxPortion(parentItem);
            if (groupMax !== Infinity) num = Math.min(num, groupMax - groupOther);
            if (num < 0) num = 0;
            item.num = num;
            this.recalcTaste();
        },
        // 计算弹窗内当前配置（名称与单份价格）
        calcCurrentConfig() {
            let extPrice = 0;
            let decideNameArr = [];
            let addFoodPrice = true;
            const selfFood = this.isSelfFood();
            this.foodAttribute.forEach((group) => {
                let hasSelected = false;
                group.children.forEach((item) => {
                    if (group.model == 2) {
                        const num = Number(item.num) || 0;
                        if (num > 0) {
                            hasSelected = true;
                            // 自助菜品属性价格按 0 计算
                            if (!selfFood) {
                                extPrice += num * (Number(item.attributePrice) || 0);
                            }
                            decideNameArr.push(num + 'x ' + item.attributeName);
                        }
                    } else if (item.isChoice) {
                        hasSelected = true;
                        if (!selfFood) {
                            extPrice += Number(item.attributePrice) || 0;
                        }
                        decideNameArr.push(item.attributeName);
                    }
                });
                if (hasSelected && !selfFood && this.getExtJson(group).priceIncrease === false) {
                    addFoodPrice = false;
                }
            });
            return {
                name: decideNameArr.join(', '),
                price: addFoodPrice
                    ? parseFloat(Number((this.food.price * this.food.actDiscount) + extPrice).toFixed(0))
                    : parseFloat(Number(extPrice).toFixed(0))
            };
        },
        // 弹窗内实时预览当前配置
        recalcTaste() {
            const config = this.calcCurrentConfig();
            this.food.payAmount = config.price;
            this.food.decideName = config.name;
        },
        // 每份口味独立保留：确保记录数组存在
        ensureTasteRecords() {
            if (!Array.isArray(this.food.tasteList)) {
                Vue.set(this.food, 'tasteList', []);
            }
            return this.food.tasteList;
        },
        // 根据每份口味记录刷新累计的名称与单价
        refreshTasteRecord() {
            const records = this.ensureTasteRecords();
            const q = this.food.quantity || 0;
            if (q <= 0) {
                this.food.decideName = null;
                return;
            }
            this.food.decideName = records.map(r => r.name).filter(n => n).join('; ');
            const total = records.reduce((sum, r) => sum + (Number(r.price) || 0), 0);
            this.food.payAmount = parseFloat(Number(total / q).toFixed(0));
        },
        // 返回第一个未填写必选项的分组
        getMissingRequiredGroup() {
            for (let i = 0; i < this.foodAttribute.length; i++) {
                const group = this.foodAttribute[i];
                if (!this.isRequired(group)) continue;
                if (group.model == 2) {
                    if (this.groupSelectedTotal(group) <= 0) return group;
                } else if (!group.children.some(item => item.isChoice)) {
                    return group;
                }
            }
            return null;
        },
        sureTasteSheet() {
            const missing = this.getMissingRequiredGroup();
            if (missing) {
                this.$alert(missing.attributeName + ' ' + this.$t('orderList.needMax1'), this.$t('common.alert'), { okLabel: this.$t('common.sure') });
                return;
            }
            const curQty = this.food.quantity || 0;
            // PerMaxCopies：含已下单的累计上限
            const cumMax = this.personCumulativeMax();
            if (cumMax !== Infinity && curQty >= cumMax) {
                this.$alert(this.$t('orderList.onePersonOrder', { num: this.food.perMaxCopies }) + ' ' + this.food.foodName, this.$t('common.alert'), { okLabel: this.$t('common.sure') });
                return;
            }
            // EveryTimeCopies：本次可点上限（与人数无关）
            const orderMax = this.perOrderMax();
            if (orderMax !== Infinity && curQty >= orderMax) {
                this.$alert(this.$t('orderList.maxEachTimeOrder', { num: this.food.everyTimeCopies }) + ' ' + this.food.foodName, this.$t('common.alert'), { okLabel: this.$t('common.sure') });
                return;
            }
            const config = this.calcCurrentConfig();
            // 每份口味独立保留：重新从 0 开始时清空历史；兼容已有份数但无记录的情况（如从服务器恢复）
            if (!this.food.quantity) {
                Vue.set(this.food, 'tasteList', []);
            } else if (!Array.isArray(this.food.tasteList) || !this.food.tasteList.length) {
                Vue.set(this.food, 'tasteList', [{
                    name: this.food.decideName || '',
                    price: (this.food.payAmount || 0) * this.food.quantity
                }]);
            }
            this.food.tasteList.push({ name: config.name, price: config.price });
            if (!this.food.quantity) {
                Vue.set(this.food, 'quantity', 1);
            } else {
                this.food.quantity += 1;
            }
            this.refreshTasteRecord();
            this.open = false;
        },
        closeTasteSheet() {
            this.open = false;
            // 未确认关闭时，恢复已确认份数的累计口味显示
            if (this.food.quantity && Array.isArray(this.food.tasteList) && this.food.tasteList.length) {
                this.refreshTasteRecord();
            }
        },
        openTasteSheet(groupId) {
            this.foodAttribute = [];
            Vue.set(this.food, 'decideName', null)
            this.tableOrderInfo = this.getItem('sessionStorage', 'tableOrderInfo');
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.$get('QRCodeOrder/GetAllFoodCustomAttributeList', { restaurantId: this.tableOrderInfo.restaurantId })
                .then(response => {
                    if (response.code == 200) {
                        this.foodAttributeAll = response.data;;
                        var arr = response.data.filter(item => {
                            return groupId.indexOf(item.id) > -1
                        })
                        arr.forEach((parentItem) => {
                            parentItem.children = response.data.filter(item => {
                                return item.parentId == parentItem.id;
                            })
                        })
                        if (arr.length > 0) {
                            arr.forEach((parentItem) => {
                                if (parentItem.model == 2) {
                                    parentItem.children.forEach((item) => {
                                        Vue.set(item, 'num', 0);
                                    });
                                }
                            });
                            this.foodAttribute = arr;
                            // 每组根据自身 ExtJson.isDefault 决定是否默认选中第一项
                            arr.forEach((parentItem) => {
                                if (!this.isDefault(parentItem)) return;
                                if (!parentItem.children || parentItem.children.length === 0) return;
                                const first = parentItem.children[0];
                                if (parentItem.model == 2) {
                                    // model=2：默认第一项 num=1
                                    Vue.set(first, 'num', 1);
                                } else {
                                    // model=1：默认选中第一项
                                    Vue.set(first, 'isChoice', true);
                                }
                            });
                            this.recalcTaste();
                            this.open = true;
                        }
                    }
                });
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
    .cartcontroll {
        position: relative;
        font-size: 0;
    }

        .cartcontroll .decrease,
        .cartcontroll .add {
            display: inline-block;
            font-size: 24px;
            width: 30px;
            height: 30px;
            color: #da5b3a;
            padding: 6px;
        }


        .cartcontroll .decrease-buffet,
        .cartcontroll .add-buffet {
            display: inline-block;
            font-size: 24px;
            width: 30px;
            height: 30px;
            color: #fff;
            padding: 6px;
        }


        .cartcontroll .count {
            display: inline-block;
            vertical-align: top;
            font-size: 18px;
            font-weight:600;
            width: 30px;
            line-height: 30px;
            text-align: center;
            color: #da5b3a;
        }

        .cartcontroll .count-buffet {
            display: inline-block;
            vertical-align: top;
            font-size: 12px;
            width: 20px;
            line-height: 30px;
            text-align: center;
            color: #fff;
        }

    .cartcontroll,
    .slide-fade-enter-active {
        -webkit-transition: all 0.3s ease;
        transition: all 0.3s ease;
    }

    .slide-fade-leave-active {
        -webkit-transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
        transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
        /* .slide-fade-leave-active for below version 2.1.8 */
        -webkit-transform: translateX(24px) rotate(360deg);
        transform: translateX(24px) rotate(360deg);
        opacity: 0;
    }

    .foods-wrapper {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        overflow-y: scroll;
    }

     .foods-wrapper h1 {
        margin: 0px;
    }

     .foods-wrapper .title {
        padding-left: 14px;
        border-left: 2px solid #d9dde1;
        font-size: 12px;
        height: 26px;
        line-height: 26px;
        color: #93999f;
        background-color: #f3f5f7;
    }

     .foods-wrapper .food-item {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin: 5px;
        padding-bottom: 10px;
        margin-right: 10px;
        position: relative;
    }

         .foods-wrapper .food-item:after {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            border-top: 1px solid rgba(7,17,27,0.1);
            content: '';
        }

         .foods-wrapper .food-item:last-child:after {
            border-top: 0;
        }

         .foods-wrapper .food-item .icon {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 57px;
            flex: 0 0 57px;
            margin-right: 10px;
        }

         .foods-wrapper .food-item .content {
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            margin-left: 5px;
        }

             .foods-wrapper .food-item .content .name {
                margin: 2px 0 8px 0;
                height: 12px;
                line-height: 12px;
                font-size: 14px;
                color: #07111b;
            }

             .foods-wrapper .food-item .content .description,
             .foods-wrapper .food-item .content .extra {
                font-size: 10px;
                line-height: 10px;
                color: #93999f;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
                height: 10px;
                line-height: 10px;
            }

                 .foods-wrapper .food-item .content .extra .count {
                    margin-right: 12px;
                    line-height: 10px;
                }

                 .foods-wrapper .food-item .content .extra .rating {
                    line-height: 10px;
                }

             .foods-wrapper .food-item .content .price .now {
                font-size: 12px;
                color: #f01414;
                font-weight: 700;
                line-height: 24px;
                padding:5px;
            }

             .foods-wrapper .food-item .content .price .old {
                font-size: 12px;
                text-decoration: line-through;
                color: #93999f;
                font-weight: 700;
                line-height: 24px;
            }

             .foods-wrapper .food-item .content .cart-wrapper {
                position: absolute;
                right: 0;
                bottom: 12px;
            }

    .form-onlyread {
        pointer-events: none;
        background: #e0e0e0;
    }

    .material-icons {
    font-size:36px;
    }
    .badge-class {
    font-size:18px;
    }
      /* ===== Taste 选择弹窗 ===== */
      .taste-sheet-list {
        padding: 0;
      }

      .taste-header {
        position: relative;
        padding: 18px 52px 12px 20px;
        background: #fff;
      }

      .taste-header.has-image {
        height: 168px;
        padding: 0;
        overflow: hidden;
      }

      .taste-header-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      .taste-header-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(180deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.55) 100%);
      }

      .taste-header-name {
        position: relative;
        z-index: 2;
        font-size: 18px;
        font-weight: 700;
        line-height: 1.4;
        color: #2b2f36;
        word-break: break-word;
      }

      .taste-header.has-image .taste-header-name {
        position: absolute;
        left: 20px;
        right: 20px;
        bottom: 16px;
        color: #fff;
        font-size: 20px;
        text-shadow: 0 2px 6px rgba(0,0,0,0.4);
      }

      .taste-close {
        position: absolute;
        top: 14px;
        right: 14px;
        z-index: 3;
        width: 38px;
        height: 38px;
        box-sizing: border-box;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0,0,0,0.4);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        color: #fff;
        cursor: pointer;
        transition: background 0.2s, transform 0.2s;
      }

      .taste-close:active {
        background: rgba(0,0,0,0.65);
        transform: scale(0.94);
      }

      .taste-body {
        padding: 16px 20px 8px;
      }

      .taste-group {
        margin-bottom: 18px;
      }

      .taste-group:last-of-type {
        margin-bottom: 12px;
      }

      .taste-group-title {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 600;
        color: #4a505a;
      }

      .taste-group-title::before {
        content: '';
        width: 3px;
        height: 13px;
        border-radius: 2px;
        background: #da5b3a;
      }

      .taste-options {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
      }

      .taste-option {
        display: inline-flex;
        align-items: baseline;
        gap: 8px;
        min-height: 36px;
        padding: 7px 14px;
        border-radius: 18px;
        border: 1px solid #eceef2;
        background: #f7f8fa;
        font-size: 13px;
        line-height: 20px;
        color: #4a505a;
        cursor: pointer;
        user-select: none;
        transition: all 0.2s ease;
      }

      .taste-option:active {
        transform: scale(0.96);
      }

      .taste-option-name {
        line-height: 22px;
      }

      .taste-option-price {
        font-size: 12px;
        font-weight: 600;
        color: #9aa1ab;
        white-space: nowrap;
      }

      .taste-option.stateChoose {
        background: #fff8f3;
        border-color: #da5b3a;
        color: #da5b3a;
        font-weight: 600;
        box-shadow: 0 2px 8px rgba(218,91,58,0.12);
      }

      .taste-option.stateChoose .taste-option-price {
        color: #da5b3a;
      }

      .taste-summary {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin: 4px 0 16px;
        padding: 10px 14px;
        background: #f7f8fa;
        border-radius: 10px;
        font-size: 13px;
        line-height: 1.6;
      }

      .taste-summary-label {
        flex: none;
        color: #9aa1ab;
      }

      .taste-summary-value {
        color: #3a3f47;
        font-weight: 500;
      }

      .taste-total {
        display: flex;
        align-items: baseline;
        justify-content: flex-end;
        gap: 8px;
        padding: 4px 2px 16px;
      }

      .taste-total-label {
        font-size: 14px;
        font-weight: 600;
        color: #6b7280;
      }

      .taste-total-price {
        font-size: 26px;
        font-weight: 800;
        line-height: 1.1;
        color: #da5b3a;
      }

      .taste-total-price em {
        font-style: normal;
        font-size: 13px;
        font-weight: 600;
        margin-left: 3px;
      }

      .taste-actions {
        padding-bottom: 22px;
      }

      .taste-confirm {
        height: 46px !important;
        border-radius: 24px !important;
        background: linear-gradient(135deg, #da5b3a, #e8856b) !important;
        color: #fff !important;
        font-size: 15px !important;
        font-weight: 600;
        letter-spacing: 0.5px;
        text-transform: unset;
        box-shadow: 0 6px 16px rgba(218,91,58,0.3);
      }

      .taste-confirm:active {
        transform: translateY(1px);
        box-shadow: 0 3px 10px rgba(218,91,58,0.25);
      }

      /* 必填标记 */
      .required-mark {
        margin-left: 3px;
        color: #e54d42;
        font-weight: 700;
      }

      /* model=2 数量选择 */
      .mul-rows {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .mul-row {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      .mul-stepper {
        flex: none;
        display: flex;
        align-items: center;
        width: 120px;
        height: 36px;
        border: 1px solid #eceef2;
        border-radius: 18px;
        overflow: hidden;
        background: #fff;
      }

      .mul-btn {
        flex: none;
        width: 36px;
        height: 36px;
        padding: 0;
        border: none;
        background: #f7f8fa;
        color: #da5b3a;
        font-size: 18px;
        line-height: 1;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background 0.2s;
      }

      .mul-btn:active {
        background: #f0f1f3;
      }

      .mul-input {
        flex: 1;
        width: 100%;
        min-width: 0;
        height: 36px;
        padding: 0;
        border: none;
        outline: none;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: #333;
        background: transparent;
        -moz-appearance: textfield;
      }

      .mul-input::-webkit-outer-spin-button,
      .mul-input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      .mul-name {
        flex: 1;
        min-width: 0;
        font-size: 13px;
        color: #4a505a;
        line-height: 1.4;
      }

      .mul-price {
        flex: none;
        font-size: 12px;
        font-weight: 600;
        color: #da5b3a;
        white-space: nowrap;
      }

      .mul-limit {
        margin-top: 2px;
        text-align: right;
        font-size: 11px;
        color: #9aa1ab;
      }
</style>



// WEBPACK FOOTER //
// src/components/CartControl.vue